// ForgotPasswordModal.js
// @author: anghello

import React, { useCallback } from 'react';
import { Col, Row, Button, Form, FormGroup, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { useAuth } from '../../../Context/Auth/AuthContext';
import { toast } from 'react-toastify';
import Strings from '../../../translations/Translations';
import WAM from '../../../services/WAM';

const schema = Yup.object().shape({
  username: Yup.string().required(Strings('email_username_is_required')),
});

export default function ForgotPasswordModal({ isOpen, toggle }) {
  const { register, errors, handleSubmit, reset } = useForm({
    validationSchema: schema,
  });
  const { toggleLoading } = useAuth();

  const onSubmit = useCallback(async (data) => {
    toggleLoading(true);
    const { username } = data;

    try {
      const response = await WAM.forgot(username);

      toggleLoading(false);

      if (response.result === 'success') {
        toast.success(Strings('a_new_password_has_been_send_to_your_email'));
        reset();
        toggle(); // Close modal on success
      } else {
        const message = (response && response.error) ? response.error : Strings('error_on_forgot_password_request');
        toast.error(message);
      }
    } catch (err) {
      toggleLoading(false);
      toast.error(Strings('general_error'));
    }
  }, [toggleLoading, reset, toggle]);

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>{Strings('forgot_your_password')}</ModalHeader>
      <ModalBody>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row form>
            <Col md={12}>
              <FormGroup>
                <input
                  type="text"
                  name="username"
                  id="username"
                  placeholder={Strings('username_email')}
                  ref={register}
                  className="form-control"
                />
                {errors.username && (
                  <p className="error-validation text-left">
                    {errors.username.message}
                  </p>
                )}
              </FormGroup>
            </Col>
          </Row>
          <h6 className="mb-0 mt-2">
            <a
              href='#/'
              className="text-primary"
              onClick={(evt) => {
                evt.preventDefault();
                toggle();
              }}
            >
              {Strings('return_to_login')}
            </a>
          </h6>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" size="lg" onClick={handleSubmit(onSubmit)}>
          {Strings('recover_password')}
        </Button>
      </ModalFooter>
    </Modal>
  );
}